"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KontributeIcon = void 0;
const React = __importStar(require("react"));
const kontribute_png_1 = __importDefault(require("src/hello_assets/assets/landing/kontribute.png"));
const KontributeIcon = () => {
    return React.createElement("span", { style: { width: 100, height: 100, borderRadius: 100, backgroundColor: "black", display: "inline-block" } },
        React.createElement("img", { src: kontribute_png_1.default, style: { width: 51, height: 82, paddingTop: 20 }, alt: "" }));
};
exports.KontributeIcon = KontributeIcon;
